// extracted by mini-css-extract-plugin
export var body = "_lc-0";
export var sectionHeader = "_lc-4";
export var shortcutColumns = "_lc-2";
export var shortcutList = "_lc-1";
export var shortcutSection = "_lc-3";